import { selectPage } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useGridPage(): number {
  return useEagGridSelector(selectPage);
}